import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { SummaryStatsOutput } from 'libs/end-to-end/src/summary-stats';
import { SummaryStatsRequest } from 'libs/end-to-end/src/summary-stats';
import { compileDataRules } from 'libs/core/src/custom-viz/data-rule-helpers';

export const SummaryStatsCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'summaryStats',
  isDataQueuingAllowed: true,
  outputFileName: 'summary_stats_output.json',
  outputSchema: SummaryStatsOutput,
  resolveFocusArea: () => null,
  resolveFilters: (request) => {
    if (request.customVizId !== 'summaryStats') {
      throw new Error('Invalid customVizId');
    }
    return request.inputs.extras.filters;
  },
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  eventProperties: (request) => {
    if (request.customVizId !== 'summaryStats') {
      throw new Error('Invalid customVizId');
    }
    return {
      'Custom Viz Type': request.customVizId,
      'Selected Dimensions': [],
      'Selected Metrics': [],
      'Selected Focus Areas': [],
      Filters: request.inputs.extras.filters,
    };
  },
  getUrlPath: () => 'explore/summary-stats',
};
